export default __webpack_public_path__ + "static/media/portfolio_500.b71f1c6b.gif";